import { CLEAR_SITE_TYPES_DISABLE_ERRORS, RECEIVE_SITE_TYPES_DISABLE_FAILURE, RECEIVE_SITE_TYPES_DISABLE_SUCCESS, REQUEST_SITE_TYPES_DISABLE_ACTION } from '../action/siteTypeAction'

export const initialState = {
  isFetching: false,
  errors: []
}

const siteTypesDisableReducer = (reduxState = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case REQUEST_SITE_TYPES_DISABLE_ACTION:
      return {
        ...reduxState,
        isFetching: true,
        errors: []
      }
    case RECEIVE_SITE_TYPES_DISABLE_SUCCESS:
      return {
        ...reduxState,
        isFetching: false,
        errors: []
      }
    case RECEIVE_SITE_TYPES_DISABLE_FAILURE:
      return {
        ...reduxState,
        isFetching: false,
        errors: payload.errors
      }

    case CLEAR_SITE_TYPES_DISABLE_ERRORS:
      return {
        ...reduxState,
        isFetching: false,
        errors: []
      }

    default:
      return reduxState
  }
}

export default siteTypesDisableReducer
